import React from 'react'
import Box from '@mui/material/Box'
import { SalesTeam } from '@user/store/salesTeam'
import { MultiSelect } from '@workwave-tidal/core/components'
import MenuItem from '@mui/material/MenuItem'
import { SalesTeamMenuItemLabel } from '@user/components/Settings/SalesTeams/utils'
import ListItemIcon from '@mui/material/ListItemIcon'
import Checkbox from '@mui/material/Checkbox'
import { useData, useHandlers } from './hooks'
import FormHelperText from '@mui/material/FormHelperText'

type Props = {
  name: string
  label: string
  disabled: boolean
  optionList: SalesTeam[]
  onChange: (value: SalesTeam[] | null) => void
  required?: boolean
  errorText?: string
}

export function SalesTeamMultiSelect(props: Props) {
  const { name, optionList, onChange, disabled, required, errorText, label } =
    props

  const {
    showError,
    isSubmitting,
    helperText,
    initialOptions,
    renderSummary,
    isOptionEqual,
    ...restUseData
  } = useData({ name, optionList, required })

  const { handleChange } = useHandlers({ name })

  return (
    <Box sx={{ backgroundColor: 'white' }}>
      <MultiSelect<SalesTeam>
        {...restUseData}
        testId="leadAssignmentSalesTeamsSelect"
        label={label}
        disabled={disabled || isSubmitting}
        required={required !== undefined ? required : true}
        optionMode="custom"
        inputMode="summary"
        density="normal"
        value={initialOptions}
        onChange={(value) => {
          onChange(value)
          handleChange(value)
        }}
        autocompleteProps={{
          isOptionEqualToValue: isOptionEqual,
          size: 'small',
        }}
        renderOption={(props, team: SalesTeam) => (
          <MenuItem {...props} key={team.id} value={team.id}>
            <ListItemIcon>
              <Checkbox checked={initialOptions.includes(team)} size="small" />
            </ListItemIcon>
            <SalesTeamMenuItemLabel salesTeam={team} />
          </MenuItem>
        )}
        renderSummary={(options) => renderSummary(options, 'Sales Teams')}
        placeholder="Search more Sales Teams"
        getLabel={(team) => team.name}
      />
      {(showError || errorText) && (
        <FormHelperText sx={{ ml: 1 }} error>
          {errorText || helperText}
        </FormHelperText>
      )}
    </Box>
  )
}
